import { createContext } from "react";

const locationContext = createContext();

export default locationContext;